/**
 * Promotion ID Tracking
 *
 * Reads the `p=` URL parameter on every page load and stores it in a
 * session cookie (`cnx_promo_id`). If a new p= value is detected, the
 * cookie is overridden and the Shopify cart attribute is updated immediately
 * via /cart/update.js — so the entire order always reflects the latest
 * promotion ID, regardless of how many products have been added.
 */

(function () {
  var COOKIE_NAME = 'cnx_promo_id';

  function getPromoIdFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get('p');
    } catch (e) {
      return null;
    }
  }

  function setCookie(name, value) {
    // Session cookie — no max-age/expires means it expires when the browser tab closes.
    // SameSite=Lax is safe for same-site navigation and required by modern browsers.
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function updateCartAttribute(value) {
    // Update the cart-level attribute so the order always has the latest promo ID.
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { '_promotion_id': value } })
    }).catch(function () {});
  }

  function updateAllLineItems(value) {
    // Fetch current cart and update Promotion ID on every existing line item.
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        cart.items.forEach(function (item, index) {
          // Preserve all existing properties, just override Promotion ID.
          var props = {};
          if (item.properties) {
            Object.keys(item.properties).forEach(function (k) {
              props[k] = item.properties[k];
            });
          }
          props['_promotion_id'] = value;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: index + 1, properties: props })
          }).catch(function () {});
        });
      })
      .catch(function () {});
  }

  // On every page load: if the URL contains p=, store/override the cookie,
  // update the cart attribute, and sync all existing line items.
  var promoId = getPromoIdFromUrl();
  if (promoId) {
    setCookie(COOKIE_NAME, promoId);
    updateCartAttribute(promoId);
    updateAllLineItems(promoId);
  }

  // Expose a helper so other scripts can read the cookie value if needed.
  window.CnxPromo = {
    get: function () {
      return getCookie(COOKIE_NAME);
    }
  };
})();
